import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT
var roottj = window.TJAPI_ROOT

//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/externaldept/list', qs.stringify(params))
}
//获取列表数据
export const serveunamelist = (params) => {
  return axios.post(root + '/set/externaldept/serveunamelist', qs.stringify(params))
}

//获取单个客户信息
export const getBySerial = (params) => {
  return axios.post(root + '/set/externaldept/getBySerial', qs.stringify(params))
}


//获取列表数据
export const getpinyinlistData = (params) => {
  return axios.post(root + '/set/externaldept/pinyinlist', qs.stringify(params))
}


//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/externaldept/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root + '/set/externaldept/detail', {params: params})
}

export const getContactorDetail = (params) => {
  return axios.get(root + '/set/externaldept/getContactorDetail', {params: params})
}

//保存某一行的数据；oldserveuguid批量修改销售客服用的
export const saveData = (params) => {
  if (params.unitguid || params.oldserveuguid) {//修改
    return axios.post(root + '/set/externaldept/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/set/externaldept/save', qs.stringify(params))
  }
}

export const updateServeruguid = (params) => {
    return axios.post(root + '/set/externaldept/updateServeruguid', qs.stringify(params))
}

export const updateSimple= (params) => {
  return axios.post(root + '/set/externaldept/updateSimple', qs.stringify(params))
}

//获取下拉框、单选按钮的绑定数据
export const getControlData = () => {
  return axios.post(root + '/set/externaldept/getcontroldata')
}

//根据当前人的独立核算编号获取对应经销商信息
export const getExternalByIndependent = () => {
  return axios.post(root + '/set/externaldept/getexternalbyindependent')
}
//获取供应商
export const suppliers = (params) => {
  return axios.post(root + '/set/externaldept/suppliers', qs.stringify(params))
}

//驳回
export const returnData = (params) => {
  return axios.post(root + '/set/externaldept/returnData', qs.stringify(params))
}
export const totalDept = (params) => {
  return axios.post(root + '/set/externaldept/totalDept', qs.stringify(params))
}

//批量修改业务员（销售客服）
export const batchupdateserveuname = (params) => {
  return axios.post(root + '/set/externaldept/batchupdateserveuname', qs.stringify(params))
}

//获取门店集合
export const getStoreList = (params) => {
  return axios.post(root + '/set/externaldept/getStoreList', qs.stringify(params))
}


export const registerCompany= (params) => {
  return axios.post(root + '/cloud/registerCompany', qs.stringify(params))
}

export const savehospital = (params) => {
  return axios.post(root + '/set/externaldeptpre/save', qs.stringify(params))
}
export const listdeptpre= (params) => {
  return axios.post(root + '/set/externaldeptpre/list', qs.stringify(params))
}
export const listhospital = (params) => {
  return axios.post(root + '/set/externaldeptpre/listhospital', qs.stringify(params))
}

export const subhospital = (params) => {
  return axios.post(roottj + '/set/externaldeptpre/quanyouxueSub', qs.stringify(params))
}
export const removehospital = (params) => {
  return axios.post(root + '/set/externaldeptpre/remove', qs.stringify(params))
}
export const updatehospital = (params) => {
  return axios.post(root + '/set/externaldeptpre/update', qs.stringify(params))
}
export const detailhospital = (params) => {
  return axios.post(root + '/set/externaldeptpre/detail', qs.stringify(params))
}

//获取易宝收款商户号列表
export const yeepayMerchantnolist = () => {
  return axios.post(root + '/set/externaldept/yeepayMerchantnolist')
}



// WEBPACK FOOTER //
// ./src/api/set/externaldept.js